import { animate } from './animate'
import  bezier from 'cubic-bezier'
import * as MovementTypes from '../../constants/MovementTypes'
import * as BallMovementModes from '../../constants/BallMovementModes'
import * as sounds from '../../constants/Sounds'
import * as RotationDirection from '../../constants/RotationDirection'
import { getParabolaABC, calculateDistance } from './helper.js'
import * as THREE from 'three';
import Vec2D from 'vector2d'

export function BallMoveTo(ball, gameSpeed, time, position, options, cancelationToken) {

    var startPosition = {Top: ball.CurrentPosition.Top, Left: ball.CurrentPosition.Left, Height: ball.CurrentPosition.Height};
    var topDiff = position.Top - startPosition.Top;
    var leftDiff = position.Left - startPosition.Left;
    var distance = calculateDistance(startPosition, position);
    var passOnHead = options.passOnHead;
    var withOpacity = options.withOpacity;
    const headHeight = 2.0;

    let leftRotationKoaf;
    let topRotationKoaf;
    calculateDeviationParams(options.rotation);

    if(startPosition.Top != position.Top || startPosition.Left != position.Left)
      startRotateBallAnimation();

    //console.log(`animate ball movement: ${options.type} rotation: ${options.rotation} mode: ${options.ballMovementMode} passOnHead: ${options.passOnHead} distance: ${distance}`);
    let maxHeight = 0;
    let a = 0, b = 0, c = 0;
    let res;
    switch(options.type) {
      case MovementTypes.Short_Pass:

            if(distance > 50)
              window.SoundComponent.play(sounds.SHORT_PASS);

            if(options.ballMovementMode == BallMovementModes.LinearNoPause) {
              return animate({
                duration: gameSpeed * time,
                timing: function(t) {
                  return t;
                },
                draw: function(progress) {
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, 0);
                  processBallOpacity(ball, progress, withOpacity);
                }
              }, 
              cancelationToken);
            }

            if(options.ballMovementMode == BallMovementModes.PauseWithDeceleration) {             
              let initialSpeed = options.initialSpeed == null ? 500 : options.initialSpeed;
              time = time * 0.9
              let acceseleration = 2*(initialSpeed*time/100.0 - distance)/(time*time)*10000;
              //console.log(`initialSpeed: ${initialSpeed} acceseleration: ${acceseleration} time: ${time}`);
    
              let startPosition_vec = Vec2D.ObjectVector(startPosition.Left, startPosition.Top);
              let direction = Vec2D.ObjectVector(position.Left - startPosition.Left, position.Top - startPosition.Top).normalise();
              let acceleration_normalized = direction.clone().mulS(-1);
              return animate({
                  duration: gameSpeed * time,
                  timing: function(t) {
                    return t;
                  },
                  draw: function(progress) {
                    let inner_time = time * progress;
                    var current = startPosition_vec.clone().add(direction.clone().mulS(initialSpeed * inner_time / 100.0)).add(acceleration_normalized.clone().mulS(acceseleration*inner_time*inner_time/20000));
                    ball.setCurrentPosition(current.y, current.x, 0);
                    processBallOpacity(ball, progress, withOpacity);
                  }
                }, 
                cancelationToken).then(()=> pauseRotateBallAnimation());
            }

            return animate({
                duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
                //timing: options.ballMovementMode == BallMovementModes.NoPauseWithDeceleration ? bezier(.27,.24,.29,.98, 1000) : bezier(.4,.51,.42,.94, 1000),
                timing: bezier(.4,.51,.42,.94, 1000),
                draw: function(progress) {
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, 0);
                  processBallOpacity(ball, progress, withOpacity);
                }
              }, 
              cancelationToken).then(()=> pauseRotateBallAnimation());

        break;

      case MovementTypes.Out:
              maxHeight = 2.3 * 100 / 16.5;
              let startHeight = 1.8 * 100 / 16.5;
              res = getParabolaABC(0,startHeight,0.2,maxHeight,1,passOnHead == true ? headHeight* 100 / 16.5 : 0);
              a = res.a;
              b = res.b;
              c = res.c;

              return animate({
                duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
                timing: function(t) {
                  return t;
                },
                draw: function(progress) {
                  let height = a*progress*progress + b*progress + c;  
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, height);
                  processBallOpacity(ball, progress, withOpacity);
                }
              }, cancelationToken).then(()=> pauseRotateBallAnimation());
        break;

      case MovementTypes.Long_Pass:
      case MovementTypes.GK_Kick:
              //время полета t = sqrt(2*h/g)
              //то есть нужно вычислить ускорение падения g в серверных пикселях на единицу такта в квадрате, тогда, зная 
              //время полета мяча, можно вычислить максимальную высоту на которую поднялся мяч
              let maxHeight = getMaxBallFlightHeight(distance) * 100 / 16.5;
              res = getParabolaABC(0,startPosition.Height,0.5,maxHeight,1, passOnHead == true ? headHeight* 100 / 16.5 : 0);
              a = res.a;
              b = res.b;
              c = res.c;

              if(startPosition.Height == 0)
                window.SoundComponent.play(options.type == MovementTypes.Long_Pass ? sounds.LONG_PASS : sounds.GK_KICK);
              return animate({
                duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
                timing: function(t) {
                  return t;
                },
                draw: function(progress) {
                  let height = a*progress*progress + b*progress + c;  
                  let leftDeviation = getLeftDeviation(progress); 
                  let topDeviation = getTopDeviation(progress); 
                  processBallOpacity(ball, progress, withOpacity);
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
                }
              }, cancelationToken).then(()=> pauseRotateBallAnimation());
        break;
      case MovementTypes.Shot:
            let endHeight = 0.35;
            if(options.serverHeight == 1) 
              endHeight = options.onGoal ? 2.35 : 3;
            
            endHeight = endHeight * 100/16.5;

            startHeight = startPosition.Height;

            let heightDiff = endHeight - startHeight;

            window.SoundComponent.play(sounds.SHOT);
                 
            return animate({
                duration: gameSpeed * time,
                timing: function(t) {
                  return t;
                },
                draw: function(progress) {
                  let height = startHeight + heightDiff*progress;
                  let leftDeviation = getLeftDeviation(progress); 
                  let topDeviation = getTopDeviation(progress); 
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
                }
              }, cancelationToken)
                .then(()=> pauseRotateBallAnimation())
                .then(() => Promise.resolve(window.SoundComponent.onShotEnd(options.owner == 1, distance, options.isGoal == true, options.isBlocked == true)))
                .then(() => {
                  if(options.isGoal == true)
                      return putBallOnEarth(ball, cancelationToken);
                  else
                    return Promise.resolve();
                });
          break;

      case MovementTypes.Cross:
            maxHeight = 3.5 * 100 / 16.5; //максимальная высота 3,5 метра
            res = getParabolaABC(0,0, 0.6,maxHeight,1, passOnHead == true ? headHeight * 100 / 16.5 : 0); //высота в конечной точке 2 метра (2*100/16.5)
            a = res.a;
            b = res.b;
            c = res.c;

            window.SoundComponent.play(sounds.LONG_PASS);
            //alert(options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1);
            return animate({
                duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
                timing: function(t) {
                  return t;
                },
                draw: function(progress) {
                  let height = a*progress*progress + b*progress + c; 
                  let leftDeviation = getLeftDeviation(progress); 
                  let topDeviation = getTopDeviation(progress); 
                  processBallOpacity(ball, progress, withOpacity);
                  ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
                }
              }, cancelationToken).then(()=> pauseRotateBallAnimation());
            break;  

        default:
          throw "Unknown ball movement type " + options.type;
    }

    function getMaxBallFlightHeight(distance) {
        //filed length = 720

        if(distance > 0 && distance <= 50)
          return 1.5;

        if(distance > 50 && distance <= 100)
          return 3;
        
        if(distance > 100 && distance <= 200)
          return 4;

        if(distance > 200 && distance <= 300)
          return 6;

        if(distance > 300)
          return 7.5;

        return 0.5;
    }

    function startRotateBallAnimation(){
        if(ball.refs == null || ball.refs.ball3d == null){ //2d ball only
          ball.Div.style.animationName = startPosition.Left < position.Left ? "rotate-right" : "rotate-left";
          ball.Div.style.animationPlayState = "running";
        }
    }

    function pauseRotateBallAnimation(){
      return new Promise(function(resolve, reject) {
        if(ball.refs == null || ball.refs.ball3d == null){ //2d ball only
            ball.Div.style.animationPlayState = "paused";
        }
        resolve();
      });
    }

    function calculateDeviationParams(direction) {
        let {left, top} = calculateDeviationAmplitudes(startPosition, position, direction, distance);
        //console.log(`deviation-left: ${left.toFixed(2)} deviation-top: ${top.toFixed(2)}`);

        leftRotationKoaf = getParabolaABC(0,0, 0.5,left, 1,0);
        topRotationKoaf = getParabolaABC(0,0, 0.5,top, 1,0);
    }

    function getLeftDeviation(progress) {
        return leftRotationKoaf.a*progress*progress + leftRotationKoaf.b*progress + leftRotationKoaf.c;  
    }
    
    function getTopDeviation(progress) {
        return topRotationKoaf.a*progress*progress + topRotationKoaf.b*progress + topRotationKoaf.c;
    }

    function calculateDeviationAmplitudes(startPosition, endPosition, direction, distance) {
      if(direction == RotationDirection.NONE)
        return {
          left: 0,
          top: 0
        }
      
      let amplitude = getMaxDeviationAmplitude(distance);

      let dTop = Math.abs(amplitude*(endPosition.Left - startPosition.Left)/distance);
      let dLeft = Math.abs(amplitude*(endPosition.Top - startPosition.Top)/distance);

        if(endPosition.Top > startPosition.Top) { // если пас сверху вниз
          if(endPosition.Left > startPosition.Left){ // и слева направо
            //console.log(" пас сверху вниз и слева направо");
            if(direction == RotationDirection.LEFT) // если левая подкрутка 
                return {
                  left: dLeft,
                  top: -dTop
                }
              else  // если правая подкрутка 
                return {
                  left: -dLeft,
                  top: dTop
                }
          }
          else{ // и справо налево
            //console.log(" пас сверху вниз и справо налево");
            if(direction == RotationDirection.LEFT) // если левая подкрутка 
                return {
                  left: dLeft,
                  top: dTop
                }
              else  // если правая подкрутка 
                return {
                  left: -dLeft,
                  top: -dTop
                }
          }
        } else { // если пас снизу вверх
          if(endPosition.Left > startPosition.Left){ // и слева направо
            //console.log("пас снизу вверх и слева направо");
            if(direction == RotationDirection.LEFT) // если левая подкрутка 
                return {
                  left: -dLeft,
                  top: -dTop
                }
              else  // если правая подкрутка 
                return {
                  left: dLeft,
                  top: dTop
                }
          }
          else{ // и справо налево
            //console.log("пас снизу вверх и справо налево");
            if(direction == RotationDirection.LEFT) // если левая подкрутка 
                return {
                  left: -dLeft,
                  top: dTop
                }
              else  // если правая подкрутка 
                return {
                  left: dLeft,
                  top: -dTop
                }
          }
        }
    }

    function getMaxDeviationAmplitude(distance) {
      return distance / 18;
    }

    function putBallOnEarth(ball, cancelationToken) {
      let startHeight = ball.CurrentPosition.Height
      let heightDiff = 0 - ball.CurrentPosition.Height;
      
      return animate({
        duration: gameSpeed * 5,
        timing: function(t) {
          return t;
        },
        draw: function(progress) {
          let height = startHeight + heightDiff*progress;
          ball.setCurrentPosition(ball.CurrentPosition.Top, ball.CurrentPosition.Left, height);
        }
      }, cancelationToken)
    }

    function processBallOpacity(ball, progress, withOpacity) {
      if(withOpacity) {
        if(progress > 0 && progress < 0.4)
          ball.setOpacity(0.4 - progress)
        else if(progress > 0.6 && progress <= 1.0)
          ball.setOpacity((progress-0.6)/0.4)
      }
      else {
        ball.setOpacity(1)
      }
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Animations/BallMoveTo.js
 **/